import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LetDatePickerComponent } from '@shared/let-datepicker/let-date-picker.component';
import dayjs from 'dayjs';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { BatchJobScheduleSearchParams } from '../batch-job-schedule/batch-job-schedule-search-params.model';
import { BatchJobSearchParams } from '../batch-job/batch-job-search-params.model';
import { BatchService } from '../batch.service';

@Component({
  selector: 'app-batch-search',
  imports: [
    ReactiveFormsModule,
    CheckboxModule,
    Button,
    InputText,
    LetDatePickerComponent,
  ],
  templateUrl: './batch-search.component.html',
  styleUrl: './batch-search.component.css',
})
export class BatchSearchComponent implements OnInit {
  ngOnInit(): void {
    this.resetForm();
    this.doSearch();
  }

  batchService = inject(BatchService);

  form = new FormGroup({
    fritekst: new FormControl(''),
    fraDato: new FormControl<Date | undefined>(undefined),
    tilDato: new FormControl<Date | undefined>(undefined),
  });

  onClickSearch() {
    this.doSearch();
  }

  doSearch() {
    const searchParams = this.form.value;
    this.batchService.searchBatchJob(searchParams as BatchJobSearchParams);

    this.batchService.searchBatchJobSchedule(
      searchParams as BatchJobScheduleSearchParams
    );
  }

  resetForm() {
    this.form.setValue({
      fritekst: '',
      fraDato: dayjs().startOf('day').subtract(1, 'day').toDate(),
      tilDato: dayjs().startOf('year').add(2, 'year').toDate(),
    });
  }

  onClickReset() {
    this.resetForm();
    this.doSearch();
  }
}
